import { render, staticRenderFns } from "./CallClientLabel.vue?vue&type=template&id=37c89384&scoped=true"
import script from "./CallClientLabel.vue?vue&type=script&lang=js"
export * from "./CallClientLabel.vue?vue&type=script&lang=js"
import style0 from "./CallClientLabel.vue?vue&type=style&index=0&id=37c89384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c89384",
  null
  
)

export default component.exports